module.exports = __webpack_public_path__ + "static/img/pay_suc.ec2ea63.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/common/img/pay_suc.png
// module id = vROo
// module chunks = 37